import React, { useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { IoIosCall } from "react-icons/io";

import { maskPhoneNumber } from "../../utils/maskPhoneNumber";
import { PRODUCT_NAME } from "../../constants/config";
import CustomDialog from "../../widgets/Dialog/Dialog";
import CustomSnackbar from "../../widgets/Snackbar/Snackbar";
import useCall from "../../store/backend/useCall";
import useUpdateNote from "../../store/backend/useUpdateNote";
import Loader from "../../components/Loader/Loader";
import SecondaryButton from "../../widgets/Button/SecondaryButton/SecondaryButton";
import { useCustomerInfoQuery } from "../../hooks/api";

import "./UserDetailsContainer.css";


const handleCall = (setShowConfirmationPopup) => {
  setShowConfirmationPopup(true);
};

const confirmCall = (
  phoneNumber,
  admissionNumber,
  type,
  uamId,
  call,
  setShowConfirmationPopup,
  setShowCallPopup,
  setIsLoadingCall,
  setProviderTrackingId,
  setShowSnackbar,
  setSnackbarMessage
) => {
  setIsLoadingCall(true);
  call(
    {
      callerPhoneNumber: phoneNumber,
      user_id: admissionNumber,
      student_id_type: type,
      student_id: uamId,
      productName: PRODUCT_NAME,
    },
    {
      onSuccess: (data) => {
        setProviderTrackingId(data.provider_tracking_id);
        setShowConfirmationPopup(false);
        setShowCallPopup(true);
        setIsLoadingCall(false);
      },
      onError: (error) => {
        setShowConfirmationPopup(false);
        setSnackbarMessage("Call failed");
        setIsLoadingCall(false);
        setShowSnackbar(true);
      },
    }
  );
};

const handleCloseConfirmationPopup = (setShowConfirmationPopup) => {
  setShowConfirmationPopup(false);
};

const handleCloseSnackbar = (setShowSnackbar) => {
  setShowSnackbar(false);
};

const handleCallLogs = (uamId, navigate) => {
  navigate(`/call-logs/${uamId}`);
};

const handleCancelledOrders = (navigate,uamId) => {
navigate(`/CancelledOrders?uamId=${uamId}`);
};

const handleCloseCallPopup = (setShowCallPopup) => {
  setShowCallPopup(false);
};

const handleSaveNotes = (
  providerTrackingId,
  notes,
  updateNote,
  setShowCallPopup
) => {
  updateNote(
    { provider_tracking_id: providerTrackingId, note: notes },
    {
      onSuccess: () => {
        setShowCallPopup(false);
      },
      onError: (error) => {
      },
    }
  );
};
const handlOnClickOrderModification =(navigate,uamId)=>{
    navigate(`/orderModification?uamId=${uamId}`)

}
const UserDetailsContainer = ({ phoneNumber, admissionNumber }) => {
  const { type } = useParams();
  const [searchParams] = useSearchParams();

  const uamId = searchParams.get("uamId");
  const verticalId = searchParams.get("verticalId");
  const navigate = useNavigate();
  const [isLoadingCall, setIsLoadingCall] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [showCallPopup, setShowCallPopup] = useState(false);
  const [notes, setNotes] = useState("");
  const [providerTrackingId, setProviderTrackingId] = useState("");
  const {
    data: customerInfo,
    isLoading: isCustomerInfoLoading,
    error: errorOnCustomerInfo,
  } = useCustomerInfoQuery({
    uam_id: uamId,
    selectedBusinessVerticalId: verticalId,
  });

  const { mutate: call } = useCall();
  const { mutate: updateNote } = useUpdateNote();

  if (isCustomerInfoLoading) {
    return <Loader />;
  }

  return (
    <div className="user-details-container">
      <div className="content">
        {customerInfo && customerInfo.length > 0 && (
          <div className="user-details">
            <div className="details-header">
              <h2 className="details-title">Student Details</h2>
              <div className="details-header__actions">
                <SecondaryButton
                  onClick={() => handlOnClickOrderModification(navigate, uamId)}
                >
                  Order Modification
                </SecondaryButton>
                <SecondaryButton
                  onClick={() => handleCancelledOrders(navigate, uamId)}
                >
                  Order Cancellations
                </SecondaryButton>
                <SecondaryButton onClick={() => handleCallLogs(uamId, navigate)}>
                  Call Logs
                </SecondaryButton>
              </div>
            </div>

            <div className="table-container">
              <table className="user-table">
                <tbody>
                  <tr>
                    <td className="field">First Name</td>
                    <td>{customerInfo[0].firstName}</td>
                  </tr>
                  <tr>
                    <td className="field">Last Name</td>
                    <td>{customerInfo[0].lastName}</td>
                  </tr>
                  <tr>
                    <td className="field">Phone Number</td>
                    <td className="phone-cell">
                      {maskPhoneNumber(customerInfo[0].phone)}
                      <IoIosCall
                        className="call-icon"
                        size={35}
                        onClick={() => handleCall(setShowConfirmationPopup)}
                        disabled={isLoadingCall}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      <CustomDialog
        isOpen={showConfirmationPopup}
        handleOnClose={() =>
          handleCloseConfirmationPopup(setShowConfirmationPopup)
        }
      >
        <div className="popup-content">
          <p>Are you sure you want to continue with the call?</p>
          <div className="button-container">
            <SecondaryButton
              onClick={() =>
                confirmCall(
                  phoneNumber,
                  admissionNumber,
                  type,
                  uamId,
                  call,
                  setShowConfirmationPopup,
                  setShowCallPopup,
                  setIsLoadingCall,
                  setProviderTrackingId,
                  setShowSnackbar,
                  setSnackbarMessage
                )
              }
              disabled={isLoadingCall}
            >
              Yes
            </SecondaryButton>
            <SecondaryButton
              onClick={() =>
                handleCloseConfirmationPopup(setShowConfirmationPopup)
              }
            >
              Cancel
            </SecondaryButton>
          </div>
        </div>
      </CustomDialog>
      <CustomDialog
        isOpen={showCallPopup}
        handleOnClose={() => handleCloseCallPopup(setShowCallPopup)}
      >
        <div className="popup-content">
          <h2>Note</h2>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Write your notes here..."
            rows="10"
            style={{ width: "100%" }}
          />
          <div className="button-container">
            <SecondaryButton
              onClick={() =>
                handleSaveNotes(
                  providerTrackingId,
                  notes,
                  updateNote,
                  setShowCallPopup
                )
              }
            >
              Save Notes
            </SecondaryButton>
            <SecondaryButton
              onClick={() => handleCloseCallPopup(setShowCallPopup)}
            >
              Cancel
            </SecondaryButton>
          </div>
        </div>
      </CustomDialog>
      <CustomSnackbar
        message={snackbarMessage}
        isOpen={showSnackbar}
        handleClose={() => handleCloseSnackbar(setShowSnackbar)}
      />
    </div>
  );
};

export default UserDetailsContainer;
